import { ReactElement } from "react";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";
import { ROUTES } from "../../utils/routes";

interface LinkCardProps {
    title: string;
    link: string;
}

const LinkCard = (props: LinkCardProps): ReactElement => {
    return (
        <div>
            <Link to={props.link} className="mr-2">
                {props.title}
            </Link>
        </div>
    );
};

export default function Navigator(): ReactElement {
    if (!window.location.hostname.includes("localhost")) return <Redirect to={ROUTES.notfound} />;
    return (
        <div style={{ padding: "12px" }}>
            <LinkCard title="Certificate Validation - in iFrame (test)" link={"/test"} />
            <LinkCard title="LinkedIn Certificate Generator" link={ROUTES.linkedinCertificateLinkGenerator} />
            <LinkCard title="UTF-8 Converter" link={ROUTES.utf8converter} />
        </div>
    );
}
